import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CircularProgress } from 'components/circularProgress';
import Input from 'components/input';

import {
  CIRCULAR_PROGRESS_SIZE_NAMES,
  CIRCULAR_PROGRESS_TYPES,
} from 'components/circularProgress/constants';
import { isNumber } from 'helpers';
import { isBrokerageAdmin } from 'helpers/checkUsersRoles';
import { updateCompanyServicesPrice } from 'pages/tours/actions';
import { Toastify } from 'hooks';
import { TOAST_TYPES } from 'constants';
import { TOAST_MESSAGES } from 'constants';

export function ServicesOrderSummary(props) {
  const {
    title,
    services,
    handlePay,
    isPaid,
    fixedPercentAmount,
    isLoadingPayCompanyServices,
    note,
    tourId,
    hasBtn = true,
    hasSetPriceOpportunity = true,
    disablePriceSet = false,
  } = props;
  const [editingPriceServiceId, setEditingPriceServiceId] = useState(null);
  const [currentServicePrice, setCurrentServicePrice] = useState(null);
  const [isLoadingSavingServicePrice, setIsLoadingSavingServicePrice] =
    useState(false);

  const user = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();

  const laterChargeSubtotal = services?.reduce(
    (acc, item) => Number(acc) + Number(item?.price),
    0
  );
  const laterChargeSubtotalPercentPrice = (
    ((laterChargeSubtotal || 0) * fixedPercentAmount) /
    100
  ).toFixed(0);
  const laterChargeTotal =
    Number(laterChargeSubtotal) + Number(laterChargeSubtotalPercentPrice);

  const handleChangePrice = (e) => {
    const value = e.target.value;
    if (isNumber(value) || !String(value)?.length) {
      setCurrentServicePrice(value);
    }
  };

  const handleSaveServicePrice = ({ id, price }) => {
    setIsLoadingSavingServicePrice(true);
    dispatch(
      updateCompanyServicesPrice({
        tourId: tourId,
        body: {
          service_id: id,
          price: Number(price),
        },
      })
    )
      .then(() => {
        Toastify({
          type: TOAST_TYPES.success,
          message: TOAST_MESSAGES.savedChanges,
        });
        setEditingPriceServiceId(null);
        setCurrentServicePrice(0);
      })
      .catch(() =>
        Toastify({
          type: TOAST_TYPES.error,
          message: TOAST_MESSAGES.tryAgain,
        })
      )
      .finally(() => setIsLoadingSavingServicePrice(false));
  };

  return (
    <>
      {' '}
      <div className="cardCharge">
        <h3>{title}</h3>
        {!!note && <p className="note">{note}</p>}
        <div className="titleCharge">
          <h4>More Services</h4>
        </div>
        <ul>
          {services?.map((serviceItem, idx) => (
            <li key={idx}>
              <span>{serviceItem?.title}</span>{' '}
              {!!serviceItem?.price && serviceItem?.price_fixed ? (
                `${`$${serviceItem.price}`}`
              ) : (
                <>
                  {editingPriceServiceId === serviceItem.id &&
                  isBrokerageAdmin(user) &&
                  hasSetPriceOpportunity &&
                  !disablePriceSet ? (
                    <div className="price_input_container">
                      <Input
                        placeholder="Enter the price"
                        onChange={handleChangePrice}
                        value={currentServicePrice}
                      />
                      <button
                        className="btn cta-primary small"
                        onClick={() =>
                          handleSaveServicePrice({
                            id: serviceItem.id,
                            price: currentServicePrice,
                          })
                        }
                      >
                        {isLoadingSavingServicePrice ? (
                          <CircularProgress
                            type={CIRCULAR_PROGRESS_TYPES.white}
                            size={CIRCULAR_PROGRESS_SIZE_NAMES.extraSmall}
                          />
                        ) : (
                          'Save'
                        )}
                      </button>
                      <button
                        className="btn cta-outline-primary small"
                        onClick={() => setEditingPriceServiceId(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <span
                      className="not_specified_text underlined"
                      onClick={() => setEditingPriceServiceId(serviceItem.id)}
                    >
                      {serviceItem?.price
                        ? `$${serviceItem?.price}`
                        : 'Not specified'}
                    </span>
                  )}
                </>
              )}
            </li>
          ))}
        </ul>
        <div className="totalCard">
          <div className="amount withoutTopBorder">
            {/* Temporary hidden the HST and subtotal for comp services and the percent made 0 for correct calculation */}
            <p hidden>
              <span>Subtotal</span>{' '}
              <strong>
                {laterChargeSubtotal ? `$${laterChargeSubtotal}` : ''}
              </strong>
            </p>
            <p hidden>
              <span>HST</span>{' '}
              <strong>
                {fixedPercentAmount}% (
                {laterChargeSubtotalPercentPrice
                  ? `$${laterChargeSubtotalPercentPrice || 0}`
                  : 0}
                )
              </strong>
            </p>
          </div>
          <div className="total">
            <p>
              <span>Total</span>{' '}
              <strong>{laterChargeTotal ? `$${laterChargeTotal}` : ''}</strong>
            </p>
          </div>
        </div>
      </div>
      {!!laterChargeTotal && !isPaid && hasBtn && (
        <button
          hidden
          disabled={
            isLoadingPayCompanyServices || services.some((serv) => !serv.price)
          }
          onClick={handlePay}
          className="btn cta-primary later_charge_pay_btn"
        >
          {isLoadingPayCompanyServices ? (
            <CircularProgress
              type={CIRCULAR_PROGRESS_TYPES.white}
              size={CIRCULAR_PROGRESS_SIZE_NAMES.small}
            />
          ) : (
            `Pay $${laterChargeTotal}`
          )}
        </button>
      )}
    </>
  );
}
